export const expertiseFunc = (Accordion) => {
    const accordeon = document.querySelectorAll('.expertise__container');

    if(accordeon) {
      const accOptions = {
        duration: 300,
      }

      accordeon.forEach(el => {
        new Accordion(el, accOptions);
      })
    }
}